import React from 'react';
import { Star, CheckCircle, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';
interface TestimonialCardProps {
  name: string;
  location: string;
  age?: number;
  text: string;
  delay?: number;
  tag?: string;
}
export function TestimonialCard({
  name,
  location,
  text,
  delay = 0,
  tag
}: TestimonialCardProps) {
  return <motion.div initial={{
    opacity: 0,
    scale: 0.95
  }} whileInView={{
    opacity: 1,
    scale: 1
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay
  }} className="bg-white p-6 rounded-2xl shadow-lg border border-purple-100 relative flex flex-col h-full" data-id="element-56">
      {tag && <div className="absolute -top-3 left-6 bg-purple-100 text-purple-700 text-xs font-bold px-3 py-1 rounded-full border border-purple-200" data-id="element-57">
          {tag}
        </div>}

      <div className="flex items-center gap-1 mb-3 mt-2" data-id="element-58">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-59" />)}
      </div>

      <p className="text-gray-700 italic mb-6 flex-grow text-sm leading-relaxed" data-id="element-60">
        "{text}"
      </p>

      <div className="flex items-center gap-3 pt-4 border-t border-gray-50 mt-auto" data-id="element-61">
        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-pink-400 to-purple-500 flex items-center justify-center text-white font-bold text-sm shadow-sm" data-id="element-62">
          {name.charAt(0)}
        </div>
        <div data-id="element-63">
          <div className="flex items-center gap-1" data-id="element-64">
            <p className="font-bold text-gray-900 text-sm" data-id="element-65">{name}</p>
            <CheckCircle className="w-3 h-3 text-green-500" data-id="element-66" />
            <span className="text-[10px] text-green-600 font-medium" data-id="element-67">
              Compra verificada
            </span>
          </div>
          <div className="flex items-center gap-1 text-xs text-gray-500" data-id="element-68">
            <MapPin className="w-3 h-3" data-id="element-69" />
            {location}
          </div>
        </div>
      </div>
    </motion.div>;
}